import { AlarmIcon } from "@phosphor-icons/react"

import { PagePlaceholder } from "@/components/page-placeholder"

export function RemindersPage() {
  return (
    <PagePlaceholder
      title="Reminders"
      description="Nothing to remind you of yet."
      icon={AlarmIcon}
    />
  )
}
